import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';

import Seo from '../components/Seo';
import { api } from '../lib/api';
import { useLang } from '../i18n';

// Revoca del consenso alla newsletter (art. 7.3 GDPR): deve essere facile
// quanto darlo, quindi un link e un click.
//
// La cancellazione parte da una POST innescata dal bottone, non dal semplice
// caricamento della pagina: una GET che cancella viene eseguita dai prefetcher
// dei browser e dagli scanner antivirus delle caselle aziendali, che
// disiscriverebbero chi non ha cliccato nulla. Il token e' la firma HMAC
// dell'indirizzo generata dal backend (token_disiscrizione): senza, chiunque
// potrebbe disiscrivere l'indirizzo di chiunque.
export default function Unsubscribe() {
  const { t } = useLang();
  const [params] = useSearchParams();
  const email = params.get('e') || '';
  const token = params.get('t') || '';
  const [stato, setStato] = useState(email && token ? 'idle' : 'invalid');

  const conferma = async () => {
    setStato('busy');
    try {
      await api.post('/newsletter/unsubscribe', { email, token });
      setStato('done');
    } catch (e) {
      setStato(e?.response?.status === 403 ? 'invalid' : 'error');
    }
  };

  return (
    <>
      <Seo title={t('unsubscribe.seoTitle')} description={t('unsubscribe.body')} noIndex />

      <div className="wrap max-w-2xl py-24 md:py-32">

        {stato === 'done' ? (
          <>
            <h1 className="display-xl mt-3">{t('unsubscribe.done')}</h1>
          </>
        ) : stato === 'invalid' ? (
          <>
            <h1 className="display-xl mt-3">{t('unsubscribe.title')}</h1>
            <p className="prosa mt-5" role="alert">{t('unsubscribe.invalid')}</p>
          </>
        ) : (
          <>
            <h1 className="display-xl mt-3">{t('unsubscribe.title')}</h1>
            <p className="prosa mt-5">{t('unsubscribe.body')}</p>
            <p className="label mt-2 break-all text-inchiostro/70">{email}</p>
            {stato === 'error' && (
              <p className="prosa mt-4 text-marsala" role="alert">{t('unsubscribe.error')}</p>
            )}
            <button
              type="button"
              className="btn btn-solid mt-8"
              onClick={conferma}
              disabled={stato === 'busy'}
              data-testid="unsubscribe-confirm"
            >
              {t('unsubscribe.confirm')}
            </button>
          </>
        )}

        <div className="mt-10">
          <Link className="btn btn-line" to="/">{t('unsubscribe.back')}</Link>
        </div>
      </div>
    </>
  );
}
